export default {
	name: "add-or-update-campaign-modal",
	props: ["heading", "modalId", "showModal", "campaign"],
	emits: ["okClicked"],
	data() {
		return {
			//campaign: null,
			modalHeading: null,
			modalComponentId: null,
			campaignToSave: {
				campaignId: null,
				campaignName: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				siteIds: {
					value: [],
					hasError: false,
					errorMessage: null
				},
				startDate: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				endDate: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				bannerImage: null,
				bannerExistsForCampaign: false
			},
			sites: [],
			initialiseActiveFromDate: true,
			initialiseActiveToDate: true,
			formIsSaving: false,
			isEdit: false
		};
	},
	methods: {
		getCampaign(){
			this.campaignToSave.campaignId =  this.campaign.campaignId;
			this.campaignToSave.campaignName.value = this.campaign.campaignName;
			//this.campaignToSave.siteId.value = this.campaign.siteId;
			this.campaignToSave.startDate.value = this.campaign.startDate;
			this.campaignToSave.endDate.value = this.campaign.endDate;
			this.campaignToSave.bannerExistsForCampaign = this.campaign.bannerImage !== null;
			this.isEdit = true;
		},
		getSites(){
			systemService.getSites().then(
				response => {
					this.sites = response.data.result;
					console.log("campaign", this.campaign);
					if(this.campaign !== null && this.campaign !== undefined){
						this.getSitesByCampaign();
					}
				}
			);
		},
		getSitesByCampaign(){
			competitionService.getSitesByCampaign(this.campaign.campaignId).then(
				response => {
					if(response.status === 200){
						var sitesForCampaign = response.data.result;
						this.campaignToSave.siteIds.value = [];
						for(let i = 0; i < this.sites.length; i++){
							for(let j = 0; j < sitesForCampaign.length; j++){
								if(this.sites[i].siteId === sitesForCampaign[j].siteId){
									this.sites[i].isChecked = true;
									this.campaignToSave.siteIds.value.push(this.sites[i].siteId);
								}
							}
						}
					}
				}
			);
		},
		onSiteCheck(event, site){
			console.log("event", event);
			console.log("site", site);
			if(event.target.checked){
				this.campaignToSave.siteIds.value.push(site.siteId);
			}
			else{
				let index = this.campaignToSave.siteIds.value.indexOf(site.siteId);
				if(index > -1){
					this.campaignToSave.siteIds.value.splice(index, 1);
				}
			}
		},
		onActiveStartDateSelect(date){
			this.initialiseActiveFromDate = false;
			this.campaignToSave.startDate.value = date;
		},
		onActiveEndDateSelect(date) {
			this.initialiseActiveToDate = false;
			this.campaignToSave.endDate.value = date;
		},
		onBannerImageAttach(event){
			if(event.target.files !== null && event.target.files.length > 0){
				this.campaignToSave.bannerImage = event.target.files[0];
			}
			else{
				this.campaignToSave.bannerImage = null;
			}
			console.log("file", this.campaignToSave.bannerImage);
			if(this.campaignToSave.bannerImage === null){
				this.campaignToSave.bannerImage = "Choose File";
			}
			// else{
			// 	this.campaignToSave.bannerImage.file.name = this.fileUpload.file.name;
			// }
		},
		downloadBannerForCampaign(){
			competitionService.downloadBannerForCampaign(this.campaign.campaignId);	
		},
		onModalCloseClick(){
			this.clearModel();
			this.$emit("okClicked");
		},
		saveCampaign(){
			console.log("save clicked");
			this.formIsSaving = true;
			let request = {
				campaignId: this.campaignToSave.campaignId,
				campaignName: this.campaignToSave.campaignName.value,
				siteIds: this.campaignToSave.siteIds.value,
				startDate: this.campaignToSave.startDate.value !== null ? moment(this.campaignToSave.startDate.value).format("DD/MM/YYYY") : this.campaignToSave.startDate.value,
				endDate: this.campaignToSave.endDate.value !== null ? moment(this.campaignToSave.endDate.value).format("DD/MM/YYYY") : this.campaignToSave.endDate.value,
			};
			let formData = new FormData();
			formData.append("request", JSON.stringify(request));
			if(this.campaignToSave.bannerImage !== null){
				formData.append("bannerImage", this.campaignToSave.bannerImage);
			}
			competitionService.addOrUpdateCampaign(formData).then(
				response => {
					if(response.status === 400){
						if(response.data.addOrUpdateCampaignValidationResponse.campaignNameValidationResponse !== null){
							this.campaignToSave.campaignName.hasError = response.data.addOrUpdateCampaignValidationResponse.campaignNameValidationResponse.hasError;
							this.campaignToSave.campaignName.errorMessage = response.data.addOrUpdateCampaignValidationResponse.campaignNameValidationResponse.message;
						}
						if(response.data.addOrUpdateCampaignValidationResponse.siteIdsToLinkValidationResponse !== null){
							this.campaignToSave.siteIds.hasError = response.data.addOrUpdateCampaignValidationResponse.siteIdsToLinkValidationResponse.hasError;
							this.campaignToSave.siteIds.errorMessage = response.data.addOrUpdateCampaignValidationResponse.siteIdsToLinkValidationResponse.message;
						}
						if(response.data.addOrUpdateCampaignValidationResponse.startDateValidationResponse !== null){
							this.campaignToSave.startDate.hasError = response.data.addOrUpdateCampaignValidationResponse.startDateValidationResponse.hasError;
							this.campaignToSave.startDate.errorMessage = response.data.addOrUpdateCampaignValidationResponse.startDateValidationResponse.message;
						}
						if(response.data.addOrUpdateCampaignValidationResponse.endDateValidationResponse !== null){
							this.campaignToSave.endDate.hasError = response.data.addOrUpdateCampaignValidationResponse.endDateValidationResponse.hasError;
							this.campaignToSave.endDate.errorMessage = response.data.addOrUpdateCampaignValidationResponse.endDateValidationResponse.message;
						}
						if(response.data.addOrUpdateCampaignValidationResponse.bannerValidationResponse !== null){
							this.campaignToSave.endDate.hasError = response.data.addOrUpdateCampaignValidationResponse.bannerValidationResponse.hasError;
							this.campaignToSave.endDate.errorMessage = response.data.addOrUpdateCampaignValidationResponse.bannerValidationResponse.message;
						}
					}
					if(response.status === 200){
						this.clearModel();
						this.$emit("okClicked");
					}
					this.formIsSaving = false;
				}
			);
		},
		clearModel(){
			this.isEdit = false;
			this.campaignToSave = {
				campaignId: null,
				campaignName: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				siteIds: {
					value: [],
					hasError: false,
					errorMessage: null
				},
				startDate: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				endDate: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				bannerImage: null,
				bannerExistsForCampaign: false
			};
		}
	},
	mounted: function () {
		this.getSites();
	},
	watch:{
		heading: {
			handler: function () {
				if(this.heading){
					this.modalHeading = this.heading;
				}
			},
			immediate: true,
			deep: true
		},
		modalId:{
			handler: function () {
				if(this.modalId){
					this.modalComponentId = this.modalId;
				}
			},
			immediate: true,
			deep: true
		},
		showModal:{
			handler: function () {
				if (this.showModal) {
					$("#" + this.modalId).modal({backdrop: 'static', keyboard: false});
				}
				else{
					$("#" + this.modalId).modal("hide");
				}
			},
			immediate: true,
			deep: true
		},
		campaign: {
			handler: function (){
				if(this.campaign !== null && this.campaign !== undefined){
					this.getSitesByCampaign();
					this.getCampaign();
				}
			}
		}
	}
};